module.exports = __webpack_public_path__ + "img/372.489cd2da.jpg";